<template>
  <div class="upgrade-log">
    <search-log
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :search="search"
    >
    </search-log>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="logList.records"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="userName"
          :label="$t('upgradeLog.userName')"
          width="140"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          :label="$t('upgradeLog.nickName')"
          width="120"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('upgradeLog.equipmentNo')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('upgradeLog.equipmentName')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="type"
          :label="$t('upgradeLog.type')"
          width="100"
          :align="'center'"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">APK</span>
            <span v-else-if="scope.row.type === 2">VMC</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mold"
          :label="$t('upgradeLog.mold')"
          width="120"
          :align="'center'"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.mold === 1">{{ $t('upgradeLog.moldMachine') }}</span>
            <span v-else-if="scope.row.mold === 2">{{ $t('upgradeLog.moldManual') }}</span>
            <span v-else-if="scope.row.mold === 3">{{ $t('upgradeLog.moldAuto') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prevVersion"
          :label="$t('upgradeLog.prevVersion')"
          width="120"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="nowVersion"
          :label="$t('upgradeLog.nowVersion')"
          width="120"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('upgradeLog.createTime')"
          width="160"
          :align="'center'"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchLog from "_c/upgrade/SearchLog.vue";

export default {
  name: "UpgradeLog",
  components: {
    SearchLog
  },
  data() {
    return {
      loading: false,
      logList: {
        records: [],
        totalSize: 0
      },
      search: {
        startTime: "",
        endTime: "",
        type: null,
        mold: null,
        prevVersion: "",
        nowVersion: "",
        userName: "",
        nickName: "",
        equipmentNo: "",
        equipmentName: ""
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalSize: 0
      }
    };
  },
  mounted() {
    this.getLogList();
  },
  methods: {
    getLogList() {
      this.loading = true;
      const params = {
        ...this.search,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      this.$api
        .request(this.$url.Upgrade.logPage, this.$method.get, params)
        .then(res => {
          if (res.code === 0) {
            this.logList = res.data || { records: [], totalSize: 0 };
            this.page.totalSize = this.logList.totalSize || 0;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit(search) {
      this.search = { ...search };
      this.page.pageIndex = 1;
      this.getLogList();
    },
    resetSearch(search) {
      this.search = { ...search };
      this.page.pageIndex = 1;
      this.getLogList();
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.getLogList();
    },
    currentChange(val) {
      this.page.pageIndex = val;
      this.getLogList();
    }
  }
};
</script>

<style lang="scss" scoped>
.upgrade-log {
  .el-pagination {
    text-align: right;
    margin-top: 15px;
  }
}
</style>
